import {ApiService} from "./api.service";
import {AxiosResponse} from "axios";

export class BaseUrlService {
    public static async getBaseURL() {
        const url:string = ApiService.getInstance().getBaseURLURL();
        const result: AxiosResponse<string> | false = await ApiService.getInstance().get(url);
        if(result) {
            return <string> result.data;
        } else {
            throw new Error('Error during BaseURL fetch!');
        }
    }
}